/**
 * Minimális, típusos eseménybusz.
 * Gazda: C
 */

export type Listener<T> = (payload: T) => void

export class EventBus<M extends Record<string, unknown>> {
  private map = new Map<keyof M, Listener<never>[]>()

  on<K extends keyof M>(key: K, fn: Listener<M[K]>): () => void {
    let list = this.map.get(key)
    if (!list) {
      list = []
      this.map.set(key, list)
    }
    list.push(fn as Listener<never>)
    return () => this.off(key, fn)
  }

  off<K extends keyof M>(key: K, fn: Listener<M[K]>): void {
    const list = this.map.get(key)
    if (!list) return
    const i = list.indexOf(fn as Listener<never>)
    if (i >= 0) list.splice(i, 1)
  }

  emit<K extends keyof M>(key: K, payload: M[K]): void {
    const list = this.map.get(key)
    if (!list) return
    // Másolaton iterálunk: a kezelő leiratkozhat vagy újat adhat hozzá.
    for (const fn of list.slice()) (fn as Listener<M[K]>)(payload)
  }

  clear(): void {
    this.map.clear()
  }
}
